import React, { Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Label,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import moment from "moment";

var reformatEmployee = function (employee) {
  return employee.map(function (region) {
    var newObj = {};
    newObj["label"] = region.employee_nip + " - " + region.employee_full_name;
    newObj["value"] = region.employee_uuid;
    newObj["model"] = region;
    return newObj;
  });
};

var reformatRank = function (ranks) {
  return ranks.map(function (rank) {
    var newObj = {};
    newObj["label"] = rank.rank_name;
    newObj["value"] = rank.rank_uuid;
    newObj["model"] = rank;
    return newObj;
  });
};

var reformatType = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.retired_type_name;
    newObj["value"] = region.retired_type_uuid;
    return newObj;
  });
};

class IndexView extends Component {
  createBloc = new CreateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        promotion_employee_uuid: props.pegawai_uuid,
        promotion_period_promotion_uuid: props.uuid,
      },
      OpsiApproval: [
        { label: "Disetujui", value: "1" },
        { label: "Ditolak", value: "2" },
      ],
      employeeItems: [],
      rankItems: [],
      employeeSelected: props.pegawai_uuid,
      pangkatSelected: "",
      typeItems: [],
      typeSelected: "",
      berkasItems: [],
      loadingDetail: false,
    };
  }

  submitData = async () => {
    let arrFileName = this.state.berkasItems.map(
      (item) => item.document_type_format_code
    );

    const formData = generateFormData(this.state.dataForm, arrFileName); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.createBloc.fetchBerkasUpload(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        promotion_employee_uuid: this.props.pegawai_uuid,
        promotion_period_promotion_uuid: this.props.uuid,
        ...values,
      },
      confirm: true,
    });
    console.log(this.state.dataForm);
  };

  onChangePangkat = (rank) => {
    var model = rank.model;
    this.setState({
      pangkatSelected: rank.value,
      dataForm: {
        promotion_rank_group_room: model.rank_group_room,
        promotion_rank_uuid: rank.value,
      },
    });
  };
  onChangeEmployee = (employee) => {
    var model = employee.model;

    this.setState({
      employeeSelected: employee.value,
      employee_rank_group: model.employee_current_rank_group,
      promotion_rank_group_room_old: model.employee_current_rank_group_room,
      pangkatSelected: "",
      promotion_rank_uuid: "",
      promotion_rank_group_room: "",
      dataForm: {
        promotion_rank_uuid_old: model.employee_current_rank_uuid,
        promotion_rank_group_room_old: model.employee_current_rank_group_room,
        promotion_rank_tmt_old: model.employee_current_tmt_rank,
        promotion_employee_uuid: model.promotion_employee_uuid,
        promotion_year_period_old: model.rank_history_year_period,
        promotion_month_period_old: model.rank_history_month_period,
        promotion_rank_group_room: "",
        promotion_rank_uuid_old: model.employee_current_rank_uuid,
        promotion_position_name_old: model.employee_current_position_name,
        promotion_rank_name_old: model.employee_current_rank_name,
        promotion_rank_tmt_old_temp: moment(
          model.employee_current_tmt_rank
        ).format("DD-MM-YYYY"),
      },
    });
    console.log(this.state);

    this.createBloc.rankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              rankItems: reformatRank(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchRank({
      employee_rank_group: model.employee_current_rank_group,
      employee_rank_room: model.employee_current_rank_room,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.berkasUploadChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.employeeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              employeeItems: reformatEmployee(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.typeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              typeItems: reformatType(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.berkasGetChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              berkasItems: response.result,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.fetchBerkasGet({});

    this.createBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingDetail: true,
          });
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            this.setState({
              detail: response,
              loadingDetail: false,
              // pangkatSelected: response.promotion_rank_uuid,
              // rankItems: [
              //   { label: response.promotion_rank_name, value: response.promotion_rank_uuid }
              // ]
            });

            // this.createBloc.fetchRank({
            //   employee_rank_group: response.employee_current_rank_group,
            //   employee_rank_room: response.employee_current_rank_room,
            // });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchDetail({
      uuid: this.props.uuid,
      promotion_employee_uuid: this.props.pegawai_uuid,
    });
    //this.createBloc.fetchEmployee();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Berkas Persyaratan Kenaikan Pangkat</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label className="col-md-3">NIP</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.employee_nip !== ""
                              ? this.state.detail.employee_nip
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Nama</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.employee_full_name !== ""
                              ? this.state.detail.employee_full_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Jenis Kenaikan Pangkat</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.rank_type_name !== ""
                              ? this.state.detail.rank_type_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    {/* {this.state.berkasItems.map(function (item, index) {
                      return (
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            {item.document_type_name}
                          </Label>
                          <Col md="6">
                            <FileInput
                              name={item.document_type_format_code}
                              col="2"
                              key={`fi-${index}`}
                            />
                          </Col>
                        </Row>
                      );
                    })} */}
                    {/* 
                    {this.state.berkasItems.map((item, index) => (
                      <Row className="mb-3" key={`row-${index}`}>
                        <Label className="col-md-3 col-form-label">
                          {item.document_type_name}
                        </Label>
                        <Col md="6">
                          <FileInput
                            name={item.document_type_format_code}
                            col="2"
                            key={`fi-${index}`}
                          />
                        </Col> */}

                    {/* </Row>
                    ))} */}

                    {this.state.berkasItems.map((item, index) => (
                      <Row className="mb-3" key={`row-${index}`}>
                        <Label className="col-md-3 col-form-label">
                          {item.document_type_name}
                        </Label>
                        <Col md="6">
                          <FileInput
                            name={item.document_type_format_code}
                            col="2"
                            key={`fi-${index}`}
                          />
                        </Col>

                        <Col md="3">
                          {this.state.loadingDetail ? (
                            <Shimmer>
                              <div style={{ width: "30%", height: 15 }}></div>
                            </Shimmer>
                          ) : this.state.detail ? (
                            <>
                              {/* SK TERAKHIR */}
                              {item.requirement_document_type_uuid ===
                                "be6af619-d489-4d59-9f3b-76c4ffd93cfa" &&
                              this.state.detail.document_sk_new ? (
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn btn-sm btn-primary"
                                  href={
                                    this.state.detail.document_sk_new
                                      .documents_path
                                  }
                                >
                                  <i className="uil-file-download"></i> Download
                                  File
                                </a>
                              ) : null}

                              {/* SKPN */}
                              {item.requirement_document_type_uuid ===
                                "3678d3e1-ebe5-45c2-b540-847a4808a304" &&
                              this.state.detail.document_skpn_new ? (
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn btn-sm btn-primary"
                                  href={
                                    this.state.detail.document_skpn_new
                                      .documents_path
                                  }
                                >
                                  <i className="uil-file-download"></i> Download
                                  File
                                </a>
                              ) : null}
                            </>
                          ) : null}
                        </Col>
                      </Row>
                    ))}

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to={`?pegawai&uuid=` + this.props.uuid}>
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect
            to={
              `/kepegawaian/kenaikan_pangkat.html?pegawai&uuid=` +
              this.props.uuid
            }
          />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
